import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import sanityClient from "../../sanityClient";

const Financials = () => {
  const [annualReports, setAnnualReports] = useState([]);
  const [form990s, setForm990s] = useState([]);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "annualReport"] | order(year desc) {
        _id,
        title,
        year,
        "fileUrl": file.asset->url
      }`
      )
      .then(setAnnualReports)
      .catch(console.error);

    sanityClient
      .fetch(
        `*[_type == "form990"] | order(year desc) {
        _id,
        title,
        year,
        "fileUrl": file.asset->url
      }`
      )
      .then(setForm990s)
      .catch(console.error);
  }, []);

  return (
    <>
      <Helmet>
        <title>Financials - Habitat for Humanity Buffalo</title>
        <meta
          name="description"
          content="View Habitat Buffalo's annual reports and IRS Form 990s to learn more about our financial transparency and stewardship."
        />
      </Helmet>
      <Container className="container">
        <Header>Financials</Header>
        <Paragraph>
          We are committed to transparency. View our most recent Annual Reports
          and Form 990s below.
        </Paragraph>

        <Section>
          <Subheader>Annual Reports</Subheader>
          {annualReports.length > 0 ? (
            <List>
              {annualReports.map((report) => (
                <li key={report._id}>
                  <a
                    href={report.fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {report.title || `Annual Report ${report.year}`}
                  </a>
                </li>
              ))}
            </List>
          ) : (
            <p>No annual reports available.</p>
          )}
        </Section>

        <Section>
          <Subheader>Form 990s</Subheader>
          {form990s.length > 0 ? (
            <List>
              {form990s.map((form) => (
                <li key={form._id}>
                  <a
                    href={form.fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {form.title || `Form 990 - ${form.year}`}
                  </a>
                </li>
              ))}
            </List>
          ) : (
            <p>No Form 990s available.</p>
          )}
        </Section>
      </Container>
    </>
  );
};

const Container = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: var(--container-padding);
`;

const Header = styled.h1`
  text-align: center;
  font-size: 2.5em;
  color: var(--primary-color);
  margin-bottom: 30px;
`;

const Paragraph = styled.p`
  font-size: 1.1em;
  line-height: 1.6;
  text-align: center;
  margin-bottom: 40px;
`;

const Section = styled.div`
  margin-bottom: 40px;
`;

const Subheader = styled.h2`
  font-size: 1.5em;
  margin-bottom: 15px;
  color: var(--primary-color);
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  text-align: center;

  li {
    margin-bottom: 10px;

    a {
      display: inline-block;
      text-decoration: none;
      color: var(--primary-color);
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export default Financials;
